







































import { Vue, Component, Prop } from 'vue-property-decorator';
import ProjectList from '@/ProjectList.vue';

import { auth } from '../auth/AuthService';
import router from '../router';

@Component({
  components: {
    ProjectList,
  }
})
export default class Home extends Vue {
  sortAlternatives: string[] = [
    'Name',
    'Last updated'
  ];
  sortBy: string = this.sortAlternatives[1];
  projectFilter: string = "";
  showArchived = false;

  onClickNewProject() {
    router.push({ name: 'CreateProject' });
  }

  updated() {
    console.log(`[Home] updated. Authenticated: ${this.$store.getters.authenticated}`);

    // if (!this.$store.getters.authenticated)
    //   this.login();
  }

  login() {
    auth.login();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue